import { render, staticRenderFns } from "./theaterData.vue?vue&type=template&id=8197cb6e&scoped=true&"
import script from "./theaterData.vue?vue&type=script&lang=js&"
export * from "./theaterData.vue?vue&type=script&lang=js&"
import style0 from "./theaterData.vue?vue&type=style&index=0&id=8197cb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8197cb6e",
  null
  
)

export default component.exports